import request from '@/utils/request'

export function getUserOrderList (params) {
  return request({
    url: process.env.WEB_API + '/order/getUserOrderList',
    method: 'post',
    data: params
  })
}

export function getOrderDetails (params) {
  return request({
    url: process.env.WEB_API + '/order/getOrderDetails/' + params,
    method: 'get',
  })
}

export function cancelOrder (params) {
  return request({
    url: process.env.WEB_API + '/order/cancelOrder',
    method: 'post',
    data: params
  })
}

export function deleteOrder (params) {
  return request({
    url: process.env.WEB_API + '/order/deleteOrder',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js